module.exports = __webpack_public_path__ + "static/ko-6-video-31184fddaa5e0a0c0fa22b284890c728.mp4";